

import Api from '../../../helpers/Api';

// ACTION  TYPES
export const SET_PLAYLISTS_VIDEOS = 'SET_PLAYLISTS_VIDEOS';
const setPlaylistVideos = (videos) => ({
    type: SET_PLAYLISTS_VIDEOS,
    videos,
});

export const SET_PLAYLISTS = 'SET_PLAYLISTS';
const setPlaylists = (playlists) => ({
    type: SET_PLAYLISTS,
    playlists,
});

export const SET_FEATURED_VIDEO = 'SET_FEATURED_VIDEO';
const setFeaturedVideo = (featuredVideo) => ({
    type: SET_FEATURED_VIDEO,
    featuredVideo,
});

export const SET_CURRENT_LATEST_VIDEO = 'SET_CURRENT_LATEST_VIDEO';
const setCurrentLatestVideo = (currentLatestVideo) => ({
    type: SET_CURRENT_LATEST_VIDEO,
    currentLatestVideo,
});

export const SET_CURRENT_VIDEO_TITLE = 'SET_CURRENT_VIDEO_TITLE';
export const setCurrentVideoTitle = (currentVideoTitle) => ({
    type: SET_CURRENT_VIDEO_TITLE,
    currentVideoTitle,
});

export const SET_NOT_FOUND = 'SET_NOT_FOUND';
export const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND,
    notFound,
});

// ACTION


export const getYoutubePlaylistsIfNeeded = (limit) => (dispatch, getState) => {
    const { videos, playlists } = getState().videos.videosPage;
    const numVideos = limit ? `/${limit}` : '';

    // Just make request  if needed
    if (Object.keys(videos).length === 0 || playlists.length === 0) {
        return Api.progressGet(dispatch, `/api/v1/videos/getYoutubePlaylists${numVideos}`).then((json) => {
            if (json.status === 'success') {
                const allPromises = [
                    dispatch(setPlaylistVideos(json.data.videos)),
                    dispatch(setPlaylists(json.data.playlists))];

                return Promise.all(allPromises);
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('getYoutubePlaylists-> got error: ', error);
        });
    }

    // Resolve promise if does'nt need make fecth
    return Promise.resolve(1);
};

export const getYoutubeLatestVideoIfNeeded = () => (dispatch, getState) => {
    // check if there is already a latest video in the store and use it if present
    const { currentLatestVideo } = getState().videos.videosPage;
    const currentLatestVideoVideoId = currentLatestVideo.videoId;
    const currentLatestVideoVideoImage = currentLatestVideo.videoImage;
    const currentLatestVideoVideoTitle = currentLatestVideo.videoTitle;
    const currentLatestVideoSlug = currentLatestVideo.slug;

    if (currentLatestVideoVideoId) {
        const featuredVideo = {
            videoId: currentLatestVideoVideoId,
            videoImage: currentLatestVideoVideoImage,
            videoTitle: currentLatestVideoVideoTitle,
            slug: currentLatestVideoSlug,
        };

        return dispatch(setFeaturedVideo(featuredVideo));
    }

    // no video in store, get it from the api

    dispatch(setNotFound(false)); // Just in case it was set to true before

    const limit = 1; // only get one video

    return Api.progressGet(dispatch, `/api/v1/videos/getYoutubeLatestVideos/${limit}`).then((json) => {
        if (json.status === 'success' && json.data[0]) {
            const featuredVideo = json.data[0]; // the API returns an array of videos. Take the first (and only)

            const allPromises = [
                dispatch(setCurrentLatestVideo(featuredVideo)),
                dispatch(setFeaturedVideo(featuredVideo)),
            ];

            return Promise.all(allPromises);
        }

        if (json.status === 'success') {
            // the YouTube API can return a success response with an empty list (e.g. quota/config edge cases) -
            // don't set notFound here, that error page is meant for a specific video-by-title lookup (see
            // getYoutubeVideoByTitleIfNeeded below), not for "no featured video available on the videos home page"
            return Promise.resolve(1);
        }

        throw `error from server: ${json.message}`;
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('getYoutubeLatestVideos-> got error: ', error);
    });
};

// this will get a youtube video object by title (needs to be slugified!)
export const getYoutubeVideoByTitleIfNeeded = (videoTitle) => (dispatch, getState) => {
    if (videoTitle === getState().videos.videosPage.currentVideoTitle) {
        return Promise.resolve();
    }

    dispatch(setNotFound(false));

    dispatch(setCurrentVideoTitle(videoTitle));

    // check if we have the given video already locally (in the videos array) before calling the controller/youtube api
    const { videos } = getState().videos.videosPage;
    let videoData = false;

    // eslint-disable-next-line no-unused-vars
    for (const playlistId in videos) {
        // eslint-disable-next-line no-prototype-builtins
        if (videos.hasOwnProperty(playlistId)) {
            videoData = videos[playlistId].find((video) => video.slug === videoTitle);

            if (videoData) {
                break;
            }
        }
    }

    // if not found check if it maybe is in the video slider array
    if (!videoData) {
        const { videoSlides: videosSliderVids } = getState().videos.videosSlider;

        videoData = videosSliderVids.find((video) => video.slug === videoTitle);
    }

    // if it was found, use it
    if (videoData) {
        return dispatch(setFeaturedVideo({
            videoId: videoData.videoId,
            videoImage: videoData.videoImage,
            videoTitle: videoData.title,
            slug: videoData.slug,
        }));
    }

    // video not found locally, query the api (note, we first check if the video is in our channel and if not found we search all youtube)
    return Api.progressGet(dispatch, `/api/v1/videos/getYoutubeVideoByTitle/${videoTitle}`).then((json) => {
        if (json.status === 'success' && json.data?.slug === videoTitle) {
            const featuredVideo = json.data;

            return dispatch(setFeaturedVideo(featuredVideo));
        }

        if (json.status === 404 || json.status === 'success') {
            // Not sure why, but the API returns an arbitrary video if the video is not found with status = 'success'
            return dispatch(setNotFound(true));
        }

        throw `error from server: ${json.message}`;
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('getYoutubeVideoByTitle -> got error: ', error);
    });
};
